import { ApplicationBankListData } from "../../types/applicationBankList.type";
import { api } from "../apiCore";

export type ApplicationBankListStatusPreset =
  | ""
  | "new"
  | "active"
  | "closed"
  | "user_application"
  | "stop_factor"
  | "for_release";

interface ApplicationListQueryParams {
  status_preset: ApplicationBankListStatusPreset;
  bg_type: string;
  amount_from: string | null;
  amount_to: string | null;
  status: string;
  created_at: string;
  inn: string;
  application_bank_id: string;
  page: number;
}

// запросы для работы со списком заявок
export const applicationBankListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getApplicationBankList: builder.query<
      ApplicationBankListData,
      ApplicationListQueryParams
    >({
      query: (params) => {
        const searchParams = new URLSearchParams();
        searchParams.append("page", String(params.page));
        params.bg_type && searchParams.append("bg_type", params.bg_type);
        params.inn && searchParams.append("inn", params.inn);
        params.status && searchParams.append("status", params.status);
        params.status_preset &&
          searchParams.append("status_preset", params.status_preset);
        params.created_at &&
          searchParams.append("created_at", params.created_at);

        params.amount_from &&
          searchParams.append("amount_from", params.amount_from);
        params.amount_to && searchParams.append("amount_to", params.amount_to);

        params.application_bank_id &&
          searchParams.append(
            "application_bank_id",
            params.application_bank_id
          );

        return {
          url: `auth/system-bank/bank/kamkombank/filter-statuses`,
          params: searchParams,
        };
      },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge: (currentApplicationListData, nextApplicationListPage, { arg }) => {
        /* 
        Если запрашивается не первая страница, то загруженные заявки добавляются в массив. 
        Если меняются другие параметры (фильтры), то страница сбрасывается на 1 (в сторе), и тогда подставляются загруженные заявки вместо текущих
         */
        if (arg.page > 1) {
          currentApplicationListData.data.push(...nextApplicationListPage.data);
        } else {
          return nextApplicationListPage;
        }
      },
    }),
  }),
});

export const { useGetApplicationBankListQuery } = applicationBankListApi;
